// This prefix is used in click event selectors to mark the shadow host element when
// the event click targets a shadow DOM element eg. div>hj-shadow:custom-element>button
export const HJ_SHADOW_PREFIX = 'hj-shadow:';
